import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import { ValidationModal } from '../../components/shared/modal/ValidationModal/ValidationModal.component'
import { useGetInfiniteDrugs } from '../../hooks/queries/drugs'
import { DrugGS1DatamatrixContent, DrugTypes } from '../../model/Drug'
import { Loader } from '../shared'
import { AddDatamatrixModalProps } from './AddDatamatrix.model'
import { formatDatamatrixContent } from './AddDatamatrixModal.utils'
import { DatamatrixReader } from './DatamatrixReader'

export const AddDatamatrixModal: FunctionComponent<AddDatamatrixModalProps> = ({
  isUnmounting,
  addDatamatrix,
  onCancel,
}) => {
  const [datamatrixContent, setDatamatrixContent] = useState<DrugGS1DatamatrixContent>()

  const handleReadDatamatrix = useCallback(
    (content: DrugGS1DatamatrixContent) => {
      if (content.cip) {
        setDatamatrixContent(content)
      } else {
        addDatamatrix(formatDatamatrixContent(content))
      }
    },
    [addDatamatrix],
  )

  const {
    drugList,
    query: { isFetching },
  } = useGetInfiniteDrugs({
    filters: datamatrixContent?.cip
      ? {
          type: DrugTypes.CIP,
          search: datamatrixContent.cip.substring(1),
        }
      : null,
  })

  useEffect(() => {
    if (!datamatrixContent || isFetching) return

    const matrixContent = { ...datamatrixContent }

    const drug = drugList?.at(0)
    if (drug) {
      matrixContent.drugName = drug.name
    }

    const datamatrixText = formatDatamatrixContent(matrixContent)
    addDatamatrix(datamatrixText)
  }, [addDatamatrix, datamatrixContent, drugList, isFetching])

  return (
    <ValidationModal
      isUnmounting={isUnmounting}
      icon={undefined}
      title={
        isFetching
          ? 'Recherche de votre médicament'
          : 'Présentez le datamatrix de la boîte de vaccin à votre webcam'
      }
      onSubmit={() => {
        onCancel()
      }}
      confirmLabel="Fermer"
      confirmTheme="invalid"
      testId="modal-datamatrix-add"
    >
      {isFetching ? <Loader /> : <DatamatrixReader onReadDatamatrix={handleReadDatamatrix} />}
    </ValidationModal>
  )
}
